import {
  Component,
  computed,
  input,
  type OnChanges,
  type OnInit,
  output,
  type SimpleChanges,
  signal,
} from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { updateOrAdd } from '@core/helpers/helpers';
import { ButtonModule } from '@fino-ui/button';
import { FinoCommonModule } from '@fino-ui/common';
import { SubmittableForm } from '@fino-ui/forms';
import { FinoIconModule } from '@fino-ui/icon';
import { FinoInputModule } from '@fino-ui/input';
import { FinoTranslationModule } from '@fino-ui/translation';
import { clone, cloneDeep, filter, map, merge, pick } from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { RECEIVED_PAYMENTS_FIELDS } from './recieved-payments.constants';

@Component({
  selector: 'app-recieved-payments',
  templateUrl: './recieved-payments.component.html',
  styleUrls: ['./recieved-payments.component.sass'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    FinoInputModule,
    ButtonModule,
    FinoIconModule,
    FinoCommonModule,
    FinoTranslationModule,
  ],
})
export class ReceivedPaymentsComponent implements OnInit, OnChanges {
  public readonly form = input<SubmittableForm>(new SubmittableForm({}));

  public readonly receivedPayments = input<any[]>([]);

  readonly receivedPaymentsSubmitted = output<any>();

  public readonly isUpdateMode = signal(false);

  public readonly toggleAllDelete = signal(true);
  public receivedPaymentsFields = RECEIVED_PAYMENTS_FIELDS;

  public searchForm: SubmittableForm = new SubmittableForm({
    search: new FormControl('', []),
  });

  public readonly filteredReceivedPayments = signal<any[]>([]);

  ngOnChanges(changes: SimpleChanges) {
    const { receivedPayments } = changes;
    if (receivedPayments) {
      this.filteredReceivedPayments.set(clone(this.receivedPayments()));
    }
  }

  submit() {
    this.form().markAllAsTouched();
    if (this.form().valid) {
      const toBeAdded = this.form().value;
      if (!toBeAdded.id) {
        toBeAdded.id = uuidv4();
      }
      this.isUpdateMode.set(false);
      updateOrAdd(
        this.receivedPayments(),
        merge(toBeAdded, { selected: true }),
        'id',
      );
      this.filteredReceivedPayments.set(clone(this.receivedPayments()));
      this.searchForm.reset();

      this.receivedPaymentsSubmitted.emit(this.form().value);
      this.form().reset();
    }
  }

  readonly hasReceivedPayments = computed(() => {
    const receivedPayments = this.receivedPayments();
    return receivedPayments && receivedPayments.length > 0;
  });

  duplicateItem(item: any) {
    const cloned = cloneDeep(item);
    cloned.id = uuidv4();
    this.form().patchValue(cloned);
  }

  deleteItem(item: any, selected: boolean = true) {
    item.selected = selected;
    this.receivedPaymentsSubmitted.emit(this.form().value);
  }

  deleteAllItems() {
    this.toggleAllDelete.set(!this.toggleAllDelete());
    map(this.receivedPayments(), (d) =>
      this.deleteItem(d, this.toggleAllDelete()),
    );
  }

  editItem(item: any) {
    this.isUpdateMode.set(true);
    this.form().patchValue(pick(item, this.receivedPaymentsFields));
  }

  get isFormValid() {
    return this.form().valid;
  }

  setupFilterForm() {
    this.searchForm.controls.search.valueChanges.subscribe(
      (keyword: string) => {
        if (!keyword) {
          this.filteredReceivedPayments.set(clone(this.receivedPayments()));
          return;
        }
        this.filteredReceivedPayments.set(
          filter(this.receivedPayments(), (item) =>
            item.name.toLowerCase().includes(keyword.toLowerCase()),
          ),
        );
      },
    );
  }

  ngOnInit() {
    this.setupFilterForm();
  }
}
